export const tagTypes = {
  TAG_LEAD: "TAG_LEAD",
  TAG_REFERRAL: "TAG_REFERRAL",
  TAG_DEPOSIT: "TAG_DEPOSIT",
  TAG_SCHEDULE_CALL: "TAG_SCHEDULE_CALL",
  TAG_BAD_NUMBER_STATE: "TAG_BN",
  BAD_NUMBER_STATE: "BAD_NUMBER_STATE",
  TAG_NA: "TAG_NA",
  TAG_NA_VM: "TAG_NA_VM",
  NOT_INTERESTED_STATE: "NOT_INTERESTED_STATE",
  TAG_NI: "TAG_NI",
  TAG_WAITING: "TAG_WAITING",
  TAG_LANGUAGE: "TAG_LANGUAGE",
  TAG_TRANSFER: "TAG_TRANSFER",
  TAG_ENDED: "TAG_ENDED",
  TAG_TIER4: "TAG_TIER4",

  UNTAG_BN: "UNTAG_BN",
  UNTAG_NI: "UNTAG_NI",
  UNTAG_NA: "UNTAG_NA",
  UNTAG_SCHEDULED_CALL: "UNTAG_SCHEDULED_CALL",
  UNTAG_DEPOSIT: "UNTAG_DEPOSIT",
  UNTAG_LEAD: "UNTAG_LEAD",
  UNTAG_COMM: "UNTAG_COMM",
  UNTAG_REFERRAL: "UNTAG_REFERRAL",
  UNTAG_WAITING: "UNTAG_WAITING",
  UNTAG_LANGUAGE: "UNTAG_LANGUAGE",
  UNTAG_TRANSFER: "UNTAG_TRANSFER",
  UNTAG_ENDED: "UNTAG_ENDED",
  UNTAG_TIER4: "UNTAG_TIER4"
};
